import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = {
    activeTab: String,
  };

  connect() {
    this.showActiveTab();
  }

  activeTabValueChanged() {
    this.showActiveTab();
  }

  selectTab(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const tabName = clickedTab.dataset.tab;

    if (tabName) {
      this.activeTabValue = tabName;
    }
  }

  showActiveTab() {
    // Update tab buttons
    this.tabTargets.forEach((tab) => {
      const tabName = tab.dataset.tab;
      const isActive = tabName === this.activeTabValue;

      // Update aria-selected
      tab.setAttribute("aria-selected", isActive.toString());

      // Update data-state for styling
      tab.setAttribute("data-state", isActive ? "active" : "inactive");

      // Toggle active classes directly
      if (isActive) {
        tab.classList.add("bg-background", "text-foreground", "shadow-sm");
        tab.classList.remove("text-muted-foreground");
      } else {
        tab.classList.remove("bg-background", "text-foreground", "shadow-sm");
        tab.classList.add("text-muted-foreground");
      }
    });

    // Update panels
    this.panelTargets.forEach((panel) => {
      const panelName = panel.dataset.panel;
      const isActive = panelName === this.activeTabValue;

      // Update data-state
      panel.setAttribute("data-state", isActive ? "active" : "inactive");

      // Show/hide panels with proper animation
      if (isActive) {
        panel.removeAttribute("hidden");
        panel.style.display = "block";
        panel.style.animationDuration = "0s";
      } else {
        panel.setAttribute("hidden", "");
        panel.style.display = "none";
      }
    });
  }
}
